import { render, staticRenderFns } from "./SessionExpiresWarning.vue?vue&type=template&id=8f6f19a4&scoped=true&"
import script from "./SessionExpiresWarning.vue?vue&type=script&lang=js&"
export * from "./SessionExpiresWarning.vue?vue&type=script&lang=js&"
import style0 from "./SessionExpiresWarning.vue?vue&type=style&index=0&id=8f6f19a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6f19a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
